export const QR_DOMAINS = [
  { value: 'https://научете.рф', label: 'научете.рф (новые QR)' },
  { value: 'https://qr-data.ru', label: 'qr-data.ru (старый домен)' }
]

export const DEFAULT_QR_DOMAIN = QR_DOMAINS[0].value

export const qrLink = (identifier, baseUrl = DEFAULT_QR_DOMAIN) =>
  `${baseUrl.replace(/\/+$/, '')}/${identifier}`

export const isNaucheteHost = () => {
  if (typeof window === 'undefined') return false
  const isDomain = ['научете.рф', 'xn--80aka3a1ae2a.xn--p1ai'].includes(window.location.hostname.toLowerCase())
  const isLocalPreview = process.env.NODE_ENV !== 'production' && new URLSearchParams(window.location.search).get('brand') === 'nauchete'
  return isDomain || isLocalPreview
}
